import { Pipe, PipeTransform } from '@angular/core';
import { FileDto } from 'src/app/models/FileDto';

@Pipe({
  name: 'createdAtFilter',
  standalone: true
})
export class CreatedAtFilterPipe implements PipeTransform {
  constructor() {}

  /**
   * Filters an array of files based on their creation date.
   * Only files created within the specified date range are included.
   *
   * @param {FileDto[]} files - The array of files to filter.
   * @param {Date[]} rangeDates - An array containing two dates: the start and end of the range.
   * @returns {FileDto[]} - The filtered array of files.
   */
  transform(files: FileDto[], rangeDates: Date[]): FileDto[] {
    // Check if files or rangeDates are not provided or if rangeDates does not contain exactly two dates
    if (!files || !rangeDates || rangeDates.length !== 2) {
      return files;
    }

    // Destructure the start and end dates from the rangeDates array
    const [startDate, endDate] = rangeDates;

    // Normalize the startDate to the start of the day (00:00:00.000)
    const normalizedStartDate = new Date(startDate.setHours(0, 0, 0, 0));
    // Normalize the endDate to the end of the day (23:59:59.999)
    const normalizedEndDate = new Date(endDate.setHours(23, 59, 59, 999));

    // Filter the files array to include only files created within the normalized date range
    return files.filter((file) => {
      // Convert the file's creation date to a Date object
      const fileCreationDate = new Date(file.createdAt);
      // Normalize the file's creation date to the start of the day (00:00:00.000)
      const normalizedFileCreationDate = new Date(
        fileCreationDate.setHours(0, 0, 0, 0)
      );

      // Check if the normalized file creation date is within the normalized date range
      return (
        normalizedFileCreationDate >= normalizedStartDate &&
        normalizedFileCreationDate <= normalizedEndDate
      );
    });
  }
}
